import { apiService } from '@/shared/services/api/api.service';

export interface CreateScheduleData {
  preferredSlot1: Date;
  preferredSlot2?: Date;
  preferredSlot3?: Date;
  timezone: string;
  notes?: string;
  meetingType?: 'phone' | 'zoom';
  phoneNumber?: string;
}

export interface TrainingSchedule {
  id: string;
  userId: string;
  preferredSlot1: Date;
  preferredSlot2?: Date | null;
  preferredSlot3?: Date | null;
  timezone: string;
  status: 'PENDING' | 'CONFIRMED' | 'COMPLETED' | 'CANCELLED';
  confirmedSlot?: Date | null;
  notes?: string | null;
  meetingType?: string | null;
  zoomMeetingId?: string | null;
  zoomJoinUrl?: string | null;
  zoomStartUrl?: string | null;
  phoneNumber?: string | null;
  confirmedBy?: string | null;
  confirmedAt?: Date | null;
  completedAt?: Date | null;
  cancelledAt?: Date | null;
  cancellationReason?: string | null;
  createdAt: Date;
  updatedAt: Date;
}

class TrainingScheduleService {
  /**
   * Create a new training schedule
   */
  async createSchedule(data: CreateScheduleData): Promise<{ success: boolean; data: TrainingSchedule }> {
    const response = await apiService.post<{ success: boolean; data: TrainingSchedule }>(
      '/training-schedule',
      data
    );
    return response.data;
  }

  /**
   * Get current user's training schedule
   */
  async getMySchedule(): Promise<{ success: boolean; data: TrainingSchedule | null }> {
    try {
      const response = await apiService.get<{ success: boolean; data: TrainingSchedule }>(
        '/training-schedule/my-schedule'
      );
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return { success: true, data: null };
      }
      throw error;
    }
  }

  /**
   * Update current user's training schedule
   */
  async updateSchedule(data: Partial<CreateScheduleData>): Promise<{ success: boolean; data: TrainingSchedule }> {
    const response = await apiService.put<{ success: boolean; data: TrainingSchedule }>(
      '/training-schedule/my-schedule',
      data
    );
    return response.data;
  }
}

export const trainingScheduleService = new TrainingScheduleService();
